export default __webpack_public_path__ + "static/media/Page-1.72704ac2.svg";